import { Fragment } from 'react';
import { uniqueId } from 'lodash';

import {
  BillingPlan,
  BillingAddon,
  AppliedCoupon,
  BillingTotal,
  BillingPlanFeatures,
  BillingFreePlan,
} from 'src/components/Billing';

import { mapSolutionNameToType } from '../lib';
import { solutionFeatureDefinitions } from '../model';

import type { IBillingSubscription } from 'src/graphql/schema';

type Props = {
  subscriptions: IBillingSubscription[];
};

const Subscriptions = ({ subscriptions = [] }: Props) => {
  if (!subscriptions.length) return <BillingFreePlan />;

  return subscriptions.map((subscription) => (
    <Fragment key={uniqueId('subscription-')}>
      {subscription.plans.map((plan) => {
        const solutionType = mapSolutionNameToType(plan.externalName ?? '') ?? 'other';
        const { features, icon, badge, textAccentColor } =
          solutionFeatureDefinitions[solutionType as keyof typeof solutionFeatureDefinitions];

        return (
          <BillingPlan
            plan={plan}
            key={plan.name}
            features={<BillingPlanFeatures features={features} textAccentColor={textAccentColor} />}
            icon={icon}
            badge={badge}
          />
        );
      })}

      {subscription.addons.map((addon) => (
        <BillingAddon addon={addon} key={addon.name} />
      ))}

      {subscription.coupons?.map((coupon) => <AppliedCoupon key={coupon} coupon={coupon} />)}

      <BillingTotal
        total={subscription.total}
        currency={subscription.currencyCode}
        period={subscription.billingPeriodUnit}
      />
    </Fragment>
  ));
};

export default Subscriptions;
